import { ColumnsType } from "antd/es/table";
import { IconButton } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EditNoteIcon from "@mui/icons-material/EditNote";
import moment from "moment";
import { SanctionDetailsType } from "./FraudScreen";
import { ROUTES } from "../../../constants/frontendPaths";

export interface FraudScreenDataType {
	partnerName: string;
	sanctionStatus: string;
	paymentId: string;
	actiontaken: number | null;
	actionTakenBy: number | null;
	isExternalComplianceRequired: number;
	senderSanctiondetailResponse: string;
	receiverSanctiondetailResponse: string;
	remark1: string | null;
	remark2: string | null;
	txnCreatedDate: string;
	txnManualAllowed: number | null;
	partnerId: string;
}

export const getComplianceColumns = (
	complianceExternal1: string | null,
	handleOpenPopup: (paymentId: string) => void,
	handleRejectPopup1: (paymentId: string) => void,
	handleSanctionDetailClick: (rowData: FraudScreenDataType) => void,
	handleNoteClick: (rowData: FraudScreenDataType) => void,
	navigate: (path: string) => void,
	setSanctionDetailsType: (type: SanctionDetailsType) => void
): ColumnsType<FraudScreenDataType> => [
	{
		title: "Payment ID",
		dataIndex: "paymentId",
		key: "paymentId",
		render: (text: string, record: FraudScreenDataType) => (
			<a
				onClick={() => navigate(ROUTES.TRANSACTION_DETAILS.replace(":paymentId", text).replace(":partnerId", "1"))}
				style={{
					color: "var(--purple-light)",
					cursor: "pointer",
					textDecoration: "underline"
				}}
			>
				{text}
			</a>
		)
	},
	{
		title: "Created Date",
		dataIndex: "txnCreatedDate",
		key: "txnCreatedDate",
		sorter: (a, b) => moment(a.txnCreatedDate).unix() - moment(b.txnCreatedDate).unix(),
		width: "15%",
		render: (text) => moment(text).format("MM/DD/YYYY H:mm.ss")
	},
	{
		title: "BusinessName or DBA Name",
		dataIndex: "partnerName",
		key: "partnerName",
		sorter: (a, b) => a.partnerName.localeCompare(b.partnerName)
	},
	{
		title: "Reason Transaction Flagged",
		dataIndex: "fraudReason",
		key: "fraudReason",
		sorter: true,
		render: (text: string) => {
			if (!text) return "-";
			return text.split(",").map((reason, index) => <div key={index}>{reason.trim()}</div>);
		}
	},

	{
		title: "Manual Decision",
		key: "txnManualAllowed",
		render: (_, record) => {
			// const isDisabled =
			// 	((complianceExternal1 === "Y" && record.actiontaken !== null) ||
			// 		(complianceExternal1 === "N" && record.actionTakenBy !== 0) ||
			// 		(record.isExternalComplianceRequired === 1 &&
			// 			record.actiontaken === null &&
			// 			(record.actionTakenBy === null || record.actionTakenBy === 1) &&
			// 			complianceExternal1 === "N")) &&
			// 	record.isExternalComplianceRequired !== 0;

			const isDisabled = true;

			return (
				<div style={{ display: "flex", gap: "8px" }}>
					<IconButton color="success" disabled={isDisabled} onClick={() => handleOpenPopup(record.paymentId)}>
						<CheckIcon />
					</IconButton>
					<IconButton sx={{ color: "red" }} disabled={isDisabled} onClick={() => handleRejectPopup1(record.paymentId)}>
						<CloseIcon />
					</IconButton>
				</div>
			);
		}
	},
	{
		title: "Action Taken",
		dataIndex: "txnManualAllowed",
		key: "txnManualAllowed",
		render: (txnManualAllowed: number | null) => {
			if (txnManualAllowed === null) {
				return "Pending";
			} else if (txnManualAllowed === 1) {
				return <span style={{ color: "var(--green-primary)" }}>Approved</span>;
			} else if (txnManualAllowed === 0) {
				return <span style={{ color: "var(--red-primary)" }}>Rejected</span>;
			} else {
				return "Unknown";
			}
		},
		sorter: (a, b) => a.txnManualAllowed - b.txnManualAllowed
	}
];
